import React, { useState } from 'react';
import { change } from 'redux-form';
import { faMinusCircle, faPlusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './assets/program-array-fields.module.scss';
import { FieldInput } from '../../../../../components/redux-form/fields/FieldInput';
import { FieldDropdown } from '../../../../../components/redux-form/fields/FieldDropdown';
import { getValFromEnum } from '../../../../../components/redux-form/utils/dropdown-values';
import GeneralEnumService from '../../../../../enumerables/general-enum';

const RenderFieldArray = (props: any) => {
    const { fields } = props;

    if (fields.length === 0) {
        fields.push({});
    }

    return (
        <ul className={classNames(styles.ul, styles.targetWrap, styles.optionsWrap)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    fields={array}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                />
            ))}
        </ul>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    isNotFirst: boolean;
};

const RenderSubFields: React.FunctionComponent<Props> = ({ member, index, fields, isLast, isNotFirst }) => {
    const dispatch = useDispatch();
    const [changeSt, setChanged] = useState(false);
    const row = fields.get(index);
    const deleteRow = () => {
        if (!row.id) {
            fields.remove(index);
            setTimeout(() => {
                setChanged(!changeSt);
            }, 200);
        } else {
            dispatch(change('program-book', `${member}.status`, 2));
            setTimeout(() => {
                setChanged(!changeSt);
            }, 200);
        }
    };

    const backRow = () => {
        dispatch(change('program-book', `${member}.status`, 1));
        setTimeout(() => {
            setChanged(!changeSt);
        }, 200);
    };
    const creditStyle = {
        display: 'none',
    };

    const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
    const promptItems: SelectObject[] = getValFromEnum(EnumSet);

    if (!row.prompt) {
        row.prompt = 10;
    }
    const isApplied: boolean = +row.status === 3;
    return (
        <li style={+row.status === 2 ? creditStyle : {}} className=" w-100" key={index}>
            <div className={classNames(styles.wrappedFields, styles.wrappedFieldsOption)}>
                <FieldInput
                    name={`${member}.id`}
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name={`${member}.title`}
                    type="text"
                    disabled={isApplied}
                    wrapperConfig={{
                        classes: { inputWrapper: 'mr-3 mb-0 ' + classNames(styles.wFullWidth) },
                        label: `Option:`,
                    }}
                />
                <FieldDropdown
                    name={`${member}.prompt`}
                    data={promptItems}
                    //onChange={() => memberD.push({})}
                    textField={'label'}
                    valueField={'value'}
                    wrapperConfig={{
                        label: 'Prompt:',
                        classes: { inputWrapper: 'mr-3 mb-0 ' + classNames(styles.wFullWidth, styles.wPromptOption) },
                    }}
                />
                <div className={'d-flex'}>
                    {(!isApplied && isNotFirst) || row.id ? (
                        +row.status !== 2 ? (
                            <button
                                type="button"
                                className={classNames('btn', 'btn-outline-danger mr-3', styles.mtResponsive)}
                                title="Remove Option"
                                onClick={() => deleteRow()}
                            >
                                <FontAwesomeIcon icon={faMinusCircle} />
                            </button>
                        ) : (
                            <button type="button" className={'btn'} title="Remove Option" onClick={() => backRow()}>
                                <FontAwesomeIcon icon={faRedo} />
                            </button>
                        )
                    ) : null}
                </div>
            </div>
            {isLast ? (
                <button
                    type="button"
                    className={classNames('btn', 'btn-outline-info', ' mr-3 mt-2 ', styles.addBtn)}
                    onClick={() => fields.push({ name: '' })}
                >
                    <FontAwesomeIcon icon={faPlusCircle} /> <span>Option</span>
                </button>
            ) : null}
        </li>
    );
};
export default RenderFieldArray;
